import React from 'react';
import { Calendar, X } from 'lucide-react';

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = React.useState(true);

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-6 right-6 z-50 animate-fadeInUp"
      data-testid="floating-cta"
    >
      <div className="bg-[#00594C] text-white rounded-2xl shadow-2xl p-4 max-w-sm relative">
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-2 right-2 text-white/60 hover:text-white transition-colors"
          data-testid="floating-cta-close"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="pr-6">
          <h3 className="font-bold text-lg mb-2">Ready to Get Started?</h3>
          <p className="text-sm text-gray-200 mb-4">
            Book a consultation with our award-winning team
          </p>
          <a
            href="#book-appointment"
            className="inline-flex items-center justify-center space-x-2 bg-[#99DF63] text-[#00594C] px-6 py-3 rounded-full font-bold hover:bg-[#8BCF52] transition-all w-full"
            data-testid="floating-cta-button"
          >
            <Calendar className="w-4 h-4" />
            <span>Book Appointment</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default FloatingCTA;
